const pms_property_type = [
  { value: "sfr", name: "SFR" },
  { value: "condo", name: "Condo" },
  { value: "pud", name: "PUD" },
  { value: "commercial", name: "Commercial" },
  { value: "mixed_use", name: "Mixed Use" },
  { value: "industrial", name: "Industrial" },
  { value: "land", name: "Land" },
  { value: "2_4_units", name: "2-4 Units" },
  { value: "5_plus_units", name: "5+ Units" },
];

export default pms_property_type;



// WEBPACK FOOTER //
// ./src/constants/pms_property_type.js